import React, { Component } from "react";
import { connect } from "react-redux";
import { Autocomplete, FormHelperText, FormLabel, MenuItem, TextField, Tooltip } from "@mui/material";
import { Icon } from "__ICON_REFERENCE__";
import { IconButton } from "@mui/material";

import { withRouter } from "utilities/withRouter";
import validateQuote from "modules/createQuote/validateQuote";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { CONFIGURATION } from "utilities/configuration";
import commonUtilities from "utilities/common";

import "./groupType.css";

class GroupType extends Component {
 
    handleData = (event, type) => {

        let { handleGroupTypeChange } = this.props;
        handleGroupTypeChange & handleGroupTypeChange(type);

    };

    render() {

        const { groupType, error, groupEventAvailable } = this.props;
        let selectPlaceHolder = this.props.localize("qma-select-label");

        const groupTypes = commonUtilities.getGroupTypesByLanguage(this.props.groupTypes?.data, commonUtilities.getLanguage());

        if (groupTypes?.length > 0) {

            return (

                <div className="row group-type">
                    <div className="row form-control-wrapper with-tooltip">
                        <FormLabel>
                            <span>{this.props.localize("qma-group-type")}</span>
                            {
                                groupEventAvailable ?
                                    <Tooltip title={this.props.localize("qma-group-type-tip")} className="info-tooltip">
                                        <IconButton className="product-type-icon">
                                            <Icon
                                                name="info"
                                                className="cursor-pointer icon-16 wvi-icon-20"
                                            />
                                        </IconButton>
                                    </Tooltip> : null 
                            }
                        </FormLabel>
                        <Autocomplete data-testid="select-group-type"
                            popupIcon={CONFIGURATION.APPLY_FIELD_ADORNMENT ? <ExpandMoreIcon/> : null}
                            autoHighlight
                            value={groupTypes?.filter(type => type.code === groupType)?.length > 0 ? groupTypes?.filter(type => type.code === groupType)?.[0] : null}
                            onChange={(event, type) => this.handleData(event, type)}
                            options={groupTypes}
                            isOptionEqualToValue={(type) =>
                                type.code === groupType
                            }
                            getOptionLabel={(type) =>
                                type ? `${type.name}` : ""
                            }
                            renderOption={(props, type, index) => (
                                <li {...props}>
                                    {type.name}
                                </li>
                            )}
                            renderInput={(params) => (
                                <TextField
                                    placeholder={selectPlaceHolder}
                                    className={(error?.trim().length === 0) ? "formControl" : "errorControl formControl"}
                                    {...params}
                                />
                            )}
                        />
                    </div>
                    <FormHelperText error={error?.trim().length > 0}>
                        {error?.trim().length > 0 && (
                            error
                        )}
                    </FormHelperText>

                </div>

            );
        }

    }
}

export default withRouter(GroupType);